import axios from '@/libs/api.request';
import axiosRequest from 'axios';
import search from '@/libs/search';
import { SEED_FARM_TYPE_BIN_FEN } from '@/view/system-management/area-management/SeedFarmTypeDefine';

import { getSeedFarmList } from '@/api/modules/system-management/seedFarm-management';

export const getBinFenSeedFarmUserList = data => {
    return axios.request({
        url: 'api/accountManagement/binFenSeedFarmUserManagement/getBinFenSeedFarmUserList',
        data: data,
        method: 'post'
    });
};

export const getBinFenSeedFarmUserDetail = userBinFenSeedFarmLoginUuid => {
    return axios.request({
        url: 'api/accountManagement/binFenSeedFarmUserManagement/getBinFenSeedFarmUserDetail',
        data: { userBinFenSeedFarmLoginUuid },
        method: 'post'
    });
};

export const pageInit4UserBinFenSeedFarmEdit = () => {
    const seedFarmSearch = search.getSearchParams({ closeAllConditions: true });
    return axiosRequest.all([
        getSeedFarmList()
    ]).then(axiosRequest.spread(function (seedFarm) {
        if (seedFarm.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    seedFarm: seedFarm.data
                }
            };
        }
        else {
            return {
                code: seedFarm.code,
                message: seedFarm.message || '获取苗场列表失败',
                data: null
            };
        }
    })).catch(error => {
        console.error('页面初始化失败:', error);
        return {
            code: -1,
            message: '页面初始化失败',
            data: null
        };
    });
};

export const binFenSeedFarmUserSave = data => {
    return axios.request({
        url: 'api/accountManagement/binFenSeedFarmUserManagement/binFenSeedFarmUserSave',
        data: data,
        method: 'post'
    });
};
